import { SupabaseClient } from '@supabase/supabase-js';
import { useQueryWithErrorBoundary, useSupabaseTypedClient } from 'hooks/reactQuery';

import { TanstackQueryName } from 'types/frontend';
import { Database } from 'types/supabase';

export interface RoastCreator {
  screen_name: string;
  avatar_url: string | null;
  name: string | null;
  experience: number;
}

interface IGetRoastCreatorQueryFnParams {
  supabase: SupabaseClient<Database>;
  userId: string;
}

const getRoastCreatorQueryFn = async ({
  supabase,
  userId,
}: IGetRoastCreatorQueryFnParams): Promise<RoastCreator | null> => {
  const { data, error } = await supabase
    .from('user_profile_view')
    .select('screen_name, avatar_url, name, experience')
    .eq('id', userId)
    .single();

  if (error || !data) return null;

  const row = data as unknown as { screen_name: string; avatar_url: string | null; name: string | null; experience: number | null };

  return {
    screen_name: row.screen_name,
    avatar_url: row.avatar_url,
    name: row.name,
    experience: row.experience ?? 0,
  };
};

interface IGetRoastCreatorQueryParams {
  userId?: string | null;
}

export const useGetRoastCreatorQuery = ({
  userId,
}: IGetRoastCreatorQueryParams) => {
  const supabase = useSupabaseTypedClient();

  const { data, isPending } = useQueryWithErrorBoundary({
    queryKey: [TanstackQueryName.GetRoastCreator, userId],
    queryFn: () =>
      getRoastCreatorQueryFn({
        supabase,
        userId: userId!,
      }),
    enabled: Boolean(userId),
  });

  return {
    data: data ?? null,
    isPending,
  };
};
